import { lazy } from 'react';
import { Route, Routes } from 'react-router';
import CommonRoutes from './common';
import ChartOfAccountsRoutes from './chart-of-accounts';
import { ClearingWithChartOfAccountsRoutes, ClearingRoutes } from './clearing';
import { RegisterRoutes, RegisterWithChartOfAccountsRoutes } from './register';
import AdminRoutes from './admin';
import SettlementRoutes from './settlements';
import ReportsRoutes from './reports';
import MonitoringRoutes from './monitoring';

// Lazy load all components from the pages folder
const NotFound = lazy(() => import('./common/NotFound'));

const AllRoutes = () => (
  <Routes>
    {CommonRoutes}
    {AdminRoutes}
    {ClearingRoutes}
    {SettlementRoutes}
    {ReportsRoutes}
    {RegisterRoutes}
    {MonitoringRoutes}

    <Route path="/chart-of-accounts/:chartOfAccountsId">
      {ChartOfAccountsRoutes}
      {ClearingWithChartOfAccountsRoutes}
      {RegisterWithChartOfAccountsRoutes}
    </Route>
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AllRoutes;
